import {
  PartialResourcePage,
  ResourceForm,
} from 'src/components/resource/form/types';
import {
  CreateResourcePageDto,
  FileAsset,
  FileAssetType,
  ResourceItemType,
  ResourcePageType,
} from 'src/graphql/generated/graphql';
import { FileElement, FileType } from '@otp/ui';
import { capitalize } from 'src/utils/string';

export const mapResourceToForm = (
  resource: PartialResourcePage,
): ResourceForm => {
  return {
    type: resource.type || ResourcePageType.Document,
    name: resource.name || '',
    description: resource.description || '',
    tagIds: resource.tags?.map((tag) => tag.id) || [],
    fileAsset: (resource.items?.[0]?.currentFileVersion?.fileAsset
      ? mapResourceFileAssetToForm(
          resource.items?.[0]?.currentFileVersion?.fileAsset,
        )
      : undefined) as unknown as FileElement,
    folderIds: resource.folders?.map((folder) => folder.id) || [],
    permissionId: resource.permissionId || null,
    isDisabled: resource.isDisabled || false,
  };
};

export const mapFileFormToResource = (
  { fileAsset, comment, ...form }: ResourceForm,
  resource?: PartialResourcePage,
): CreateResourcePageDto => {
  return {
    ...form,
    resourceItems: [
      {
        ...(resource?.items?.[0]?.id ? { id: resource.items?.[0]?.id } : {}),
        description: form.description,
        name: form.name,
        type: ResourceItemType.Document,
        fileAsset: mapFormFileAssetsToResourceFileAsset(fileAsset),
        ...(comment ? { comment } : {}),
      },
    ],
  };
};

export const mapVideoFormToResource = ({
  items,
  ...form
}: ResourceForm): CreateResourcePageDto | undefined => {
  if (!items) {
    return;
  }

  const resourceItems = items.map((item) => ({
    id: item.id,
    name: item.description as string,
    description: item.description as string,
    type: ResourceItemType.Video,
    externalItem: {
      value: item.externalItem?.value || '',
    },
  }));

  return {
    ...form,
    type: ResourcePageType.Video,
    resourceItems,
  };
};

const mapResourceFileAssetToForm = (fileAsset: Partial<FileAsset>) => {
  return {
    id: fileAsset.id,
    title: fileAsset.title as string,
    type: fileAsset.type?.toLowerCase() as unknown as FileType,
    url: fileAsset.url,
  };
};

export const mapFormFileAssetsToResourceFileAsset = (
  fileAsset: FileElement,
) => {
  return {
    id: fileAsset.id as string,
    key: (fileAsset.id || fileAsset.key) as string,
    title: fileAsset.title,
    type: capitalize(fileAsset.type) as FileAssetType,
  };
};
